/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EventAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActionType from './ActionType/index'
import AppointmentRequirements from './AppointmentRequirements/index'
import Content from './Content/index'
import DeleteAction from './DeleteAction/index'
import DragHandle from './DragHandle/index'
import ExpandAction from './ExpandAction/index'
import React from 'react'
import Skip from './Skip/index'
import TysiaSubtract from 'DesignSystem/Svgs/TysiaSubtract/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EventAction({
  children,
  dragHandleProps,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="EventAction.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="EventAction.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1sPPxw': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaSubtract
  viewPath={`${viewPath}/TysiaSubtract`}
 fill={dtColorsNeutral400}
 fill2={dtColorsNeutral400}
 marginLeft={-11}
/>
</div>
<div
  data-testid="EventAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-1sPPxw': dtColorsNeutral100,'--pt-3-1sPPxw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-1sPPxw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-5-1sPPxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-6-1sPPxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-1-1sPPxw': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="EventAction.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ActionType
  viewPath={`${viewPath}/ActionType`}
/>
<AppointmentRequirements
  viewPath={`${viewPath}/AppointmentRequirements`}
/>
<Skip
  viewPath={`${viewPath}/Skip`}
/>
<div
  data-testid="EventAction.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-7-1sPPxw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="EventAction.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
<DragHandle
  viewPath={`${viewPath}/DragHandle`}
 dragHandleProps={dragHandleProps}
/>
<div
  data-testid="EventAction.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<ExpandAction
  viewPath={`${viewPath}/ExpandAction`}
/>
</div>
</div>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
{children}
</React.Fragment>)
}